import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { appConfig } from './../../../config/component-config';
import { apiConfig } from './../../../config/main-config';
import { HttpService } from './../../../http-service/http-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';
import { shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/auth-service/authService';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  static ifaValues;
  static rmList;
  static rmNameList;
  static roleName;
  static unmappedAdvisorList;
  pdfUrl$: any;
  showArrow$: BehaviorSubject<any>

  constructor(
    private httpClient: HttpClient,
    private http: HttpService) {
    this.showArrow$ = new BehaviorSubject(true);

  }


  private subject = new BehaviorSubject<any>('');


  private rmList$: Observable<any[]> | null = null;
  getRMNameListCached(): Observable<any[]> {
    let obj = {
      rmId: AuthService.getRmId(),
    };
    if (!this.rmList$) {
      this.rmList$ = this.getrmmaster(obj).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.rmList$;
  }

  getOnboardingTaskGlobal(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ONBOARDING_TASK_GLOBAL, data);
  }

  getfilterNewMyIfasSearch(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_SEARCH_LIST, data);


  }

  getMasterTaskList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_MASTER_IFA_TASK_LIST, data);
  }

  getBackofficeAdvisorSearchByName(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_BACKOFFICE_ADVISOR_SEARCH_NAME, data);
  }

  getFileTypeOrder(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_FILE_TYPE_ORDER, data);
  }

  getMyIFAValues(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_MY_IFA_DETAILS, data);
  }

  getInitialOnboardingComments(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INITIAL_ONBOARDING_COMMENTS, data);
  }
  getDeactivateResonList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_DEACTIVATE_REASON_LIST, data);
  }

  postDeactivateReson(data) {
    return this.http.postEncoded(apiConfig.MAIN_URL + appConfig.POST_DEACTIVATE_REASON_LIST, data);

  }

  postInitialOnboardingComments(data) {
    return this.http.postEncoded(apiConfig.MAIN_URL + appConfig.POST_INITIAL_ONBOARDING_COMMENTS, data);
  }

  /**
   * @author Sushil Hariakar
   * @name getNewMyIFAValues
   * @param data
   * @returns new My ifas list
   */
  getNewMyIFAValues(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_NEW_MY_IFA_DETAILS, data);
  }

  /**
 * @author Sushil Hariakar
 * @name getOnBoarding
 * @param data
 * @returns new My ifas list
 */
  getOnBoarding(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ONBOARDING_DETAILS, data);
  }
  getMyIFAValuesFilter(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.GET_MY_IFA_FILTER, data);
  }

  getMyIFAOnboarding(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_MY_IFA_ONBOARDING, data);
  }

  SearchMyIFAValues(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.SEARCH_MY_IFA_VALUES, data);
  }

  getBackofficeAumOrderListValues(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.BACKOFFICE_GET_AUM_ORDER_LIST, data);
  }

  getAumReconListGetValues(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.BACKOFFICE_GET_AUM_RECON_LIST, data)
  }

  getFolioCountValues(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.BACKOFFICE_FOLIO_COUNTS, data);
  }

  postManualTransactionFile(pre, formData, header) {
    return this.httpClient.post(apiConfig.MAIN_URL + appConfig.BACKOFFICE_UPLOAD_SIP + '?advisorId=' + pre.advisorId + '&arnRiaId=' + pre.arnRiaId + '&fileType=' + pre.fileType, formData, header)
  }

  putAumTransactionKeepOrRemove(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.BACKOFFICE_PUT_AUM_TRANSACTION_KEEP_OR_REMOVE, data);
  }

  recalculateBalanceUnitData(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.BACKOFFICE_RM_RECALCULATE_BALANCE_UNITS, data);
  }
  putMergeSundaramCode(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.BACKOFFICE_MERGE_SUNDARAM_SCHEME_CODE, data);
  }
  getArnlistChanges(data) {
    const httpParams = new HttpParams().set('advisorId', data.advisorId);
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ARN_RIA_LIST_CHANGE, httpParams);
  }
  putMergeAllSchemes(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.PUT_MERGE_ALL_SCHEMES, data);
  }
  putMergeSundaramSelect(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.BACKOFFICE_MERGE_SUNDARAM_SELECTED_SCHEME_CODE, data);
  }
  putMergeSchemeCode(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.BACKOFFICE_MERGE_SCHEME_CODE, data);
  }

  postMergeSchemeCodeBulk(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.BACKOFFICE_MERGE_SCHEME_CODE_BULK, data);
  }

  getBackofficeReports(data) {
    return null;
  }

  getReminders(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_REMINDERS, data);

  }

  changeStatusReminder(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_REMINDER, data);

  }

  getMappedUnmappedCount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.RM_MAPPED_UNMAPPED_SCHEME_COUNT_NJ_PRUDENT, data);
  }

  getDailyServicesStatusReport(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_DAILY_SERVICES_STATUS_REPORT, data);
  }

  addExpiry(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_EXPIRY_REMINDER, data);

  }

  deleteReminder(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_REMINDER, data);
  }

  editExpiry(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_REMINDER, data);

  }

  getDailyFiles(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_DAILY_FILES, data);
  }

  getHistoricFilesReport(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.FILTER_HISTORICAL_REPORT, data);
  }

  getOverviewIFAOnboarding(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_IFA_ONBOARDING_OVERVIEW, data);
  }
  updateOverviewIFAOnboarding(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_IFA_ONBOARDING_OVERVIEW, data);
  }
  getOnboardingActivity(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_IFA_ONBOARDING_ACTIVITY, data);
  }
  editActivity(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_ACTIVITY, data);
  }
  activityCommentUpdate(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.ACTIVITY_UPDATE_COMMENT, data);
  }
  activityAddComment(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ACTIVITY_ADD_COMMENT, data);
  }
  activityDeleteComment(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.ACTIVITY_DELETECOMMENT, data);
  }
  getIfaMatricData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_IFA_MATRIC_DATA, data);
  }

  postFileOrderingData(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.POST_HISTORICAL_FILE_ORDER, data);
  }

  postFileOrderingData2(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.POST_HISTORICAL_FILE_ORDER2, data);


  }

  getStageComments(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_STAGE_COMMENT, data);
  }
  deleteCommentStage(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_STAGE_COMMENT, data);
  }
  editStageComment(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_STAGE_COMMENT, data);
  }
  addStageComment(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_STAGE_COMMENT, data);
  }
  getMyIFAReconSummary(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_MY_IFA_REC_SUMMARY, data);
  }

  getCommentCount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_COMMENT_COUNT_RM_ADMIN, data);
  }
  // observable data sending

  sendDataThroughObs(value) {
    this.subject.next(value)
  }

  // get Observable Data
  getDataThroughObs(): Observable<any> {
    return this.subject.asObservable();
  }

  getBulkFilesData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_BULK_FILE_ORDER_LIST, data);
  }

  getUnmappedAdvisors(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.UNMAPPED_ADVISOR_LIST, data);
  }

  mapAdvisors(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.MAP_ADVISOR_TO_RM, data);
  }

  getSlot(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_SLOT_LIST, data);

  }
  getUpcomingDemo(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_UPCOMING_DEMO, data);

  }
  getRmUnavailability(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_UMAVAILABILITY_DATA, data);

  }
  deleteAvailability(data) {
    return this.http.putParam(apiConfig.MAIN_URL + appConfig.DELETE_SLOT, {}, data);

  }
  getPastDemos(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_PAST_DEMO, data);

  }
  updateUnavailability(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.EDIT_UNAVAILIBILITY + '?date=' + data.date + '&ids=' + data.ids + '&rmId=' + data.rmId + '&slotIds=' + data.slotIds, data);
  }
  addUnavailability(data) {
    return this.http.postEncoded(apiConfig.MAIN_URL + appConfig.ADD_UNAVAILIBILITY, data);

  }
  changeMapRM(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.CHANGE_MAP_TO_RM, data);
  }

  unavailableSlotGet(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.UNAVAILABLE_SLOTS, data);

  }

  unmapAdvisors(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UNMAP_ADVISOR_TO_RM + '?advisorId=' + data.advisorId + '&rmId=' + data.rmId, data);
  }

  ignoreAdvisors(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.IGNORE_ADVISOR_TO_RM + '?request=' + '%5B' + (data.result).toString() + '%5D', data);
  }

  getRMList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_LIST, data);
  }

  getRMNameList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_NAME_LIST, data);
  }

  getRolesList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ROLES_LIST, data);
  }

  getIncentiveBillPaidList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_BILL_PAID_LIST, data);
  }

  getIncentiveAllCount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_ALL_COUNT, data);
  }

  getIncentiveBillPaidCount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_BILL_PAID_COUNT, data);
  }

  getIncentiveUnpaidBillThisMonthList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_UPAID_BILLS_THIS_MONTH_LIST, data);
  }

  getIncentiveBillPaymentRatioList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_BILL_PAYMENT_RATIO_LIST, data);
  }

  getIncentiveTotalUnpaidBillOverallList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_TOTAL_UNPAID_BILLS_OVERALL_LIST, data);
  }

  getIncentiveUpfrontEarnedList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_UPFRONT_EARNED_LIST, data);
  }
  getIncentiveOverviewList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INCENTIVE_OVERVIEW_LIST, data);
  }
  getHierarchyList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_HIERARCHY_RM_ROLE_ACCESS_RIGHT_MAPPING, data);
  }

  addRMHierarcy(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_RM_HIERARCY, data);
  }

  getrmNameHierarcyList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_NAME_HIERARCY_LIST, data);
  }
  getNewIncentiveData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_NEW_INCENTIVE_DATA, data);
  }

  addRm(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_RM, data);
  }
  editRm(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_RM, data);
  }
  disableRm(data) {
    console.log(data);
    return this.http.put(apiConfig.MAIN_URL + appConfig.DISABLE_RM, data);
  }
  getTickets(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_TICKET, data);
  }
  getReportFilterData(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.GET_REPORT_FILTER_DATA, data);
  }
  getJsonUploadLink(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_JSON_UPLOAD_LINK, data);
  }

  getArnRiaOfAdvisors(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_FILE_ORDER_ARN_RIA_LIST, data);
  }

  getAMCList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.BACKOFFICE_AMC_LIST_GET, data);
  }

  deleteSip(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_SIP, data);
  }

  refreshDashboard(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.REFRESH_DASHBOARD, data);
  }

  deactivateAccount(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DEACTIVATE_ACCOUNT, data);
  }

  cancelAccount(data) {
    return this.http.put(apiConfig.USER + appConfig.CANCEL_ACCOUNT, data);
  }

  getFileUrlForSendy(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.RM_DASHBOARD_MISC_SENDY_FILE_URL_GET, data)
  }

  putUploadSendyExcelFile(url, data) {
    return this.httpClient.put(url, data);
  }
  postSendyDataAfterFileUpload(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.RM_DASHBOARD_POST_AFTER_SENDY_FILE_UPLOAD, data);
  }
  refreshMutualFundList(data) {
    // return this.http.get(apiConfig.MAIN_URL + appConfig.REFRESH_MF_LIST, data);
    return this.http.get(apiConfig.MF_URL + appConfig.REFRESH_MF_LIST, data);
  }

  convertToPaidDate(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.CONVERT_TO_PAID_DATE, data);
  }

  saveStockScrip(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_SCRIP_STOCK, data);
  }

  getAllRestoreTransactions(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ALL_RESTORE_TRANSACTION, data);
  }

  restoreMfTranasction(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.RESTORE_MF_TRANSACTION, data);
  }

  getPreviousComments(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_PREVIOUS_COMMENTS, data);
  }

  getComments(data) {
    console.log(data);
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_COMMENTS, data);
  }

  newGetComments(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_AUM_COMMENT, data);
  }

  addCommentRecon(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.POST_COMMENT_RECON, data);

  }

  editCommentRecon(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDITCOMMENT, data);
  }

  deleteComment(data) {
    const httpParams = new HttpParams().set('rmRmReminderCommentId', data);
    return this.http.get(apiConfig.MAIN_URL + appConfig.DELETECOMMENT, httpParams);
  }

  getClientList(data) {
    return this.http.getEncoded(apiConfig.USER + appConfig.GET_PEOPLE_CLIENT_LIST, data, 1);
  }

  getRmAdvisors(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.RM_ADVISORS, data);
  }

  getAumReminders(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_AUM_DETAILS, data)
  }

  changeReconStatus(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_RECON_REMINDER, data)
  }

  changeCallStatus(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_CALL_STATUS, data)
  }

  getRMComments(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_COMMENTS_NEW, data)
  }
  getNjComments(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_NJNEW_COMMENTS, data)
  }

  addRMComments(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_COMMENTS_NEW, data)
  }
  addnj(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_NJ_NEW, data)
  }

  getCamsList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CAMS_LIST, data)
  }

  getCamsAdvisor(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CAMS_ADVISOR, data)
  }

  getCamsArn(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CAMS_ARN, data)
  }

  addCams(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_CAMS, data);
  }

  updateCams(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_CAMS, data)
  }

  editDesc(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_DESC, data)
  }

  getUuid(data, type) {
    console.log(data, type)
    if (type === 'localdev') {
      return this.http.post(apiConfig.LOCAL_DEV_URL + appConfig.GET_UUID, data)
    } else {
      return this.http.post(apiConfig.LOCAL_URL + appConfig.GET_UUID, data)
    }
  }


  ///// Notification apis /////

  getTagMasterList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_TAGS_MASTER_LIST, data)
  }

  getTypeMasterList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_TYPE_MASTER_LIST, data)
  }

  addNotificationPost(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_NOTIFICATION_POST, data)
  }

  editNotificationPost(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.EDIT_NOTIFICATION_POST, data)
  }

  getNotificationList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_NOTIFICATION_LIST, data)
  }

  getDetailedView(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_DETAILED_VIEW, data)
  }


  private myifasdata = new BehaviorSubject('');
  private rmdata = new BehaviorSubject('');
  private reminderaumdata = new BehaviorSubject('');
  private remindercamsdata = new BehaviorSubject('');

  setCamsReminderData(value) {
    this.remindercamsdata.next(value)
  }

  getCamsReminderData() {
    return this.remindercamsdata.asObservable()
  }

  setAumReminderData(value) {
    this.reminderaumdata.next(value)
  }
  getAumReminderData() {
    return this.reminderaumdata.asObservable();
  }

  setMyIfasData(value) {
    this.myifasdata.next(value)
  }
  getMyIfasData() {
    return this.myifasdata.asObservable();
  }
  setRmData(value) {
    this.rmdata.next(value)
  }
  getRmData() {
    return this.rmdata.asObservable()
  }
  sendyGetList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.SENDY_LIST_GET, data);
  }
  addListToSendy(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_SENDY_LIST, data);
  }
  deleteListToSendy(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.DELETE_SENDY_LIST, data);
  }

  getrmmanagerdata(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_MASTER_LIST, data)
  }

  getMobileDetails() {
    let httpParams;
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_MOBILE_DETAIL_LIST, httpParams)
  }

  addAndroidDetails(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_ANDROID_DETAIL, data);
  }

  addIOSDetails(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.ADD_IOS_DETAIL, data);
  }

  deleteAndroidDetails(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_ANDROID_DETAIL, data);
  }

  deleteIOSDetails(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_IOS_DETAIL, data);
  }

  getPaidAdvisorList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_PAID_ADVISOR_LIST, data);
  }

  appendToSpreadSheet(data) {
    return this.http.postExternal(apiConfig.RM_URL + appConfig.APPEND_TO_SPREADSHEET, data)
  }

  updateToSpreadSheet(data) {
    return this.http.putEncoded(apiConfig.RM_URL + appConfig.UPDATE_TO_SPREADSHEET, data)
  }

  getExcelFileUpload(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_FILE_UPLOAD, data);
  }

  excelFileUpload(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPLOAD_TRANSACTION_FILE, data);
  }
  getIFastFileUpload(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.UPLOAD_IFAST_FILE, data);
  }

  generateIFastPdf(data) {
    return this.http.getMessage(apiConfig.MAIN_URL + appConfig.GENERATE_IFAST_PDF, data);
  }

  getIFastZiplink(data) {
    return this.http.getMessage(apiConfig.MAIN_URL + appConfig.GET_IFAST_ZIPLINK, data);
  }

  getCreditHistory(data) {
    return this.http.get(apiConfig.USER + appConfig.GET_CREDIT_HISTORY, data)
  }

  getWalletDetails(data) {
    return this.http.get(apiConfig.USER + appConfig.GET_WALLET_DETAILS, data)
  }

  static clearData() {
    this.rmList = null;
    this.rmNameList = null;
    this.roleName = null;
    this.unmappedAdvisorList = null;
    this.ifaValues = null;
  }

  /**
   * @author Sushil Hariakar
   * @description get api for transaction logs
   * @param data
   * @name getTransactionLogs
   */
  getTransactionLogs(data) {
    return this.http.get(apiConfig.TRANSACT + appConfig.GET_TRANSACTION_LOGS, data);

  }
  /**
   * @author Sushil Hariakar
   * @description get api for transaction logs
   * @name getTransactionCount
   */
  getTransactionCount(data) {
    return this.http.get(apiConfig.TRANSACT + appConfig.GET_TRANSACTION_COUNT, data);

  }
  getAccordCount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ACCORD_DATA, data)
  }
  /**
   * @author Sushil Hariakar
   * @description get api for ONBOARDING options list
   * @name getOnboardingOptions
   */
  getOnboardingOptions(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ONBOARDING_OPTIONS, data);

  }
  /**
  * @author Sushil Hariakar
  * @description get api for ONBOARDING options list Answers
  * @name getOnboardingAnswers
  */
  getOnboardingAnswers(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ONBOARDING_ANSWERS, data);

  }
  /**
 * @author Sushil Hariakar
 * @description UPDATE api for ONBOARDING options list Answers
 * @name updateOnboardingAnswers
 */
  updateOnboardingAnswers(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ONBOARDING_ANSWERS_UPDATE, data);

  }

  callDoneScheduleCall(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.CALL_DONE_SCHEDULECALL, data);

  }
  /**
* @author Sushil Hariakar
* @description UPDATE api for ONBOARDING options list Answers
* @name commonTemplateList
*/
  commonTemplateList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.
      GET_ONBOARDING_TEMPLATE_LIST, data);

  }
  /**
* @author Sushil Hariakar
* @description Get api for Myifas filter list rm
* @name getrmmaster
*/
  getrmmaster(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_NAME_MASTER_LIST, data);
  }

  scheduleCall(data) {
    return this.http.postEncoded(apiConfig.MAIN_URL + appConfig.SCHEDULE_CALL, data);
  }

  activateAutomaticaCall(data) {
    return this.http.putEncoded(apiConfig.MAIN_URL + appConfig.AUTOMATIC_CALL, data);
  }

  getUpcomingFilter(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_UPCOMING_FILTER_LIST, data);

  }

  /**
* @author Sushil Hariakar
* @description Get api for Myifas onboarding comments
* @name getOnboardingComment
*/
  getOnboardingComment(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_COMMENT_ONBOARDING, data);
  }

  /**
 * @author Sushil Hariakar
 * @description Get api for Myifas onboarding comments
 * @name postOnboardingComment
 */
  postOnboardingComment(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.POST_COMMENT_ONBOARDING, data);
  }

  postRemarkComment(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.POST_COMMENT_REMARK, data)
  }



  getCamapignListA() {
    let httpParams;
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CAMPAIGN_LIST, httpParams);
  }

  updateCampaignApi(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.UPDATE_CAMPIGN_LIST, data);

  }

  remarkCommentEdit(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.EDIT_COMMENT_REMARK, data);
  }
  remarkCommentDelete(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.DELETE_COMMENT_REMARK, data);
  }

  getRemarkComment(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_COMMENT_REMARK, data)
  }

  /**
 * @author Sushil Hariakar
 * @description Get api for Myifas PINGS interkat team member list
 * @name getInteraktTeamMemberList
 */
  getInteraktTeamMemberList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_INTERAKT_TEAMMEMBER_LIST, data);
  }
  /**
 * @author Sushil Hariakar
 * @description post api for Myifas PINGS interkat template send
 * @name postInteraktTemplates
 */
  postInteraktTemplates(data) {
    return this.http.postEncoded(apiConfig.MAIN_URL + appConfig.POST_INTERAKT_TEMPLATES, data);
  }

  /**
* @author Sushil Hariakar
* @description Get api for New Myifas filtered data
* @name getfilterNewMyIfas
*/
  getfilterNewMyIfas(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_FILTER_NEW_MYIFAS_LIST, data);
  }

  /**
* @author Sushil Hariakar
* @description delete comment by ID
* @name deleteCommentByID
*/
  deleteCommentByID(id) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.DELETE_ONBOARDING_COMMENT_BY_ID_, id);
  }

  /**
* @author Sushil Hariakar
* @description edit comment by ID
* @name editCommentByID
*/
  editCommentByID(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.EDIT_ONBOARDING_COMMENT_BY_ID_, data);
  }
  /**
* @author Sushil Hariakar
* @description get bse creds data
* @name getBSECredentials
*/
  getBSECredentials(data) {
    return this.http.getEncoded(apiConfig.TRANSACT + appConfig.GET_BSE_CREDENTIALS, data);
  }

  /**
* @author Sushil Hariakar
* @description update status teammember interakt
* @name updateInterakt
*/
  updateInterakt(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.UPDATE_INTERAKT, data);
  }
  /**
 * @author Sushil Hariakar
 * @description method is used to get the arn-ria list
 * @name getRtaDetails
 */
  getArnRiaDetails(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ARNRIA_LIST, data);
  }
  /**
 * @author Sushil Hariakar
 * @description method is used to get the arn-ria list
 * @name getRtaDetails
 */
  getRtaDetails(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RTA_LIST, data);
  }
  /**
* @author Sushil Hariakar
* @description method is used to get the AUTOUPLOAD REFRENCE LIST
* @name getAutoUploadList
*/
  getAutoUploadList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_AUTOUPLOAD_LIST, data);
  }
  /**
* @author Sushil Hariakar
* @description method is used to get the AUTOUPLOAD email LIST
* @name getAutoUploadEmailList
*/
  getAutoUploadEmailList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_AUTOUPLOAD_EMAIL_LIST, data);
  }

  /**
* @author Ankit Patel
* @descrip tionticop Transactions to order wbr2a file
* @name ticopTransactions
*/
  getTicopTransactions(data) {
    return this.http.getEncoded(apiConfig.MAIN_URL + appConfig.BACKOFFICE_AMC_TICOP_TRANSCATION_GET, data);
  }
  /**
* @author Sushil Hariakar
* @descrip POST CALL FOR AUTO UPLOAD REFRNCE
* @name addAutoUploadRefrence
*/
  addAutoUploadRefrence(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.AUTO_UPLOAD_REFRENCE_ADD, data);
  }

  /**
* @author Sushil Hariakar
* @descrip get Add on list
* @name getAddonData
*/
  getAddonData(data) {
    return this.http.get(apiConfig.USER + appConfig.GET_BILLING_ADDONS_DETAILS, data);
  }
  /**
* @author Sushil Hariakar
* @descrip post Add on list
* @name addorEditAddon
*/
  addorEditAddon(data) {
    return this.http.post(apiConfig.USER + appConfig.ADD_ON_ADD_EDIT, data);

  }
  incentivepartnerTotalUnpaidBillsList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.INCENTIVE_RESELLER_UNPAID_LIST, data)
  }

  getIncentiveMyIfasList(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.INCENTIVE_MYIFAS_LIST, data)
  }

  billingInvoiceReason() {
    return this.http.get(apiConfig.USER + appConfig.BILLING_INVOICE_REASON, null)
  }

  billingInvoiceDelete(data) {
    return this.http.put(apiConfig.USER + appConfig.BILLING_INVOICE_DELETE, data)
  }

  addSubscriptionPayee(data) {
    return this.http.post(apiConfig.USER + appConfig.ADD_PAYEE_SUBSCRIPTION, data);
  }

  searchSupply(data) {
    return this.http.get(apiConfig.USER + appConfig.SEARCH_SUPPLY, UtilService.getHttpParam(data));
  }

  addPricingSubscriptionPayee(data) {
    return this.http.post(apiConfig.PRICING_URL + appConfig.PRICING_ZOHO_ADD, data);
  }

  editSubscriptionPayee(data) {
    return this.http.put(apiConfig.USER + appConfig.EDIT_PAYEE_SUBSCRIPTION, data);
  }
  incentivepartnerPaymentListGet(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.INCENTIVE_RESELLER_PAYMENT_LIST, data)

  }
  incentivepartnerInvoiceIncentiveListGet(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.INCENTIVE_RESELLER_INVOICE_INCENTIVE_GET, data)

  }
  incentivePartnerAdvisorInvoiceTable(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.INCENTIVE_RESELLER_ADVISOR_INVOICE_GET, data)


  }

  incentivePartnerTotalCountGet(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.INCENTIVE_RESELLER_TOTAL_COUNT_GET, data)
  }

  BillingInvoiceDetails(data) {
    return this.http.get(apiConfig.USER + appConfig.BILLING_INVOICE_DETAILS, data)
  }

  billingInvoiceUpdate(data) {
    return this.http.post(apiConfig.USER + appConfig.BILLING_INVOICE_UPDATE, data)
  }

  getGstData(data) {
    return this.http.get(apiConfig.USER + appConfig.GET_GST_DATA, UtilService.getHttpParam(data));
  }

  getshowArrow(data) {
    this.showArrow$.next(data)
  }

  getsignzyKycUpdate(data) {
    return this.http.put(apiConfig.USER + appConfig.GET_SIGNZY_KYC_UPDATE, data);
  }


  getsignzyKycUpdateSend(data) {
    return this.http.post(apiConfig.USER + appConfig.GET_SIGNZY_KYC_UPDATE_SEND, data);
  }

  empanelDetails(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.EMPANEL_DETAILS, data)
  }

  empanelReffererDetails(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.EMPANEL_REFFERER_DETAILS, data)
  }

  empanelInterestRate(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.EMPANEL_INTEREST_RATE, data)
  }

  getFamilyMembers(data) {
    return this.http.getEncoded(apiConfig.USER + appConfig.GET_FAMILY_MEMBERS, data, 1);
  }

  empanelDetailsUpdate(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.EMPANEL_DETAILS_UPDATE, data)
  }

  empanelCheck(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.EMPANEL_CHECK, data)
  }

  duplicationCheck(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.DUPLICATION_CHECK, data)
  }

  selectClubFileOrder(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.FILEORDER_SELECTCLUB, data);
  }

  maxWalletUsage(data) {
    return this.http.post(apiConfig.USER + appConfig.MAX_WALLET_USE, data)
  }

  registerDeadlineWaiver(data) {
    return this.http.post(apiConfig.USER + appConfig.REGISTER_WAIVER_DEADLINE, data)
  }

  getArnNotToOrder(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.FILE_NOT_TO_ORDER_SELECTCLUB, data)
  }

  postSelectClubFileOrder(data) {
    return this.http.put(apiConfig.MAIN_URL + appConfig.FILEORDER_DATA_SAVE, data)
  }

  getCalendarHoliday(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_CALENDAR_HOLIDAY, data);

  }

  //get the RM which is available for particular module
  getRmProfile(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_PROFILE, data);

  }

  getAdvisorCallingDetails(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_CALL_DETAILS, data);

  }

  getAdvisorCallingUpcomingData(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_CALL_UPCOMING_DATA, data);

  }
  getAdvisorCallingCurrentLog(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_RM_CALL_CURRENT_DATA, data);

  }
  getAdvisorDetailsCount(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_ADVISOR_DETAILS_COUNT, data);

  }
  callBack(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.CALL_BACK + '?advisorId=' + data.advisorId + '&advisorPhnNo=' + data.advisorPhnNo + '&rmId=' + data.rmId, data);
  }

  karvySubUserQuestion(data) {
    return this.http.get(apiConfig.MAIN_URL + appConfig.GET_KARVY_SUBUSER_RESPONE, data);
  }
}
